export enum TriggerExpressionTypes {
  VALUE_CHANGE = 'VALUE_CHANGE',
  CONDITION = 'CONDITION',
  NULLEVALUATION = 'NULLEVALUATION',
  TIME_EVAL = 'TIME_EVAL'
}